import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "3", x2: "21", y1: "12", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "8 8 12 4 16 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "16 16 12 20 8 16", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "SeparatorHorizontal";
const SeparatorHorizontal = memo(themed(Icon));
export {
  SeparatorHorizontal
};
//# sourceMappingURL=separator-horizontal.js.map
